
jQuery.fn.geoarticleloader = function(params)
{
	init(this, params);

	function init(e) {
		var defaults = {
			max_autoload: 3,
			section_selector: '.main-section',
			autoload_trigger_selector: '#autoloader-trigger',
			load_button_selector: '#ajaxpaginator_load_button',
			section_url_selector: 'article.article',
			section_url_data_name: 'url',
			next_page_selector: '.article__footer',
			next_page_data_name: 'nexturl',
			pages_container_selector: '#content-container',
			onPageState: function(){}
		};
		var options = $.extend({}, defaults, params);
		var loading_state = false;

		if(!$(options.autoload_trigger_selector).length){
			return;
		}

		var autoload_iter = 0;

		$(window).bind('scroll.geoarticle',function(){
			if (!loading_state && (autoload_iter < options.max_autoload) && $.inViewport($(options.autoload_trigger_selector))) {
				loading_state = true;
				autoload_iter++;
				loadNextPage();
			}
		});

		$(options.load_button_selector).on('click.geoarticle', function(e) {
			e.preventDefault();
			autoload_iter = 0;
			loadNextPage();
			return false;
		});

		var loadNextPage = function() {
			var url = $(options.next_page_selector).last().data(options.next_page_data_name);
			if(url){
				$.post(url, {}, function(data){
					$(options.pages_container_selector).append(data);
					options.onPageLoaded.call(this, data);
					loading_state = false;
				});
			}
		};

		var articleScrollSpy = $(window).scrollspy({
			section_selector: options.section_selector,
			onChangeActive: function(el) {
				var url = $(el).find(options.section_url_selector).data(options.section_url_data_name);
				var title = $(el).find('.post-title').text();
				var page_title = title ? title : $(el).find('h1').text();
				setPageState(url, page_title);
			}
		});

		var setPageState = function(url, title) {
			var currenturl = urlhelper.getCurrentUrl();
			if (url !== currenturl) {
				urlhelper.add(url, title);
				document.title = title;
				if(options.onPageState){
					options.onPageState.call(this);
				}
			}
		};

		$(window).bind('popstate.geoarticle',function(event) {
			event.preventDefault();
			articleScrollSpy.disable();
			var current_url = urlhelper.getCurrentUrl();
			$(options.section_selector).each(function(i){
				var section_url = $(this).find(options.section_url_selector).data(options.section_url_data_name);
				if(current_url === section_url){
					urlhelper.scrollTo($(options.section_selector).eq(i));
					return;
				}
			});
			articleScrollSpy.enable();
		});
	}
};